import { minutesToHours } from "date-fns";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time. See https://www.notion.so/BP-Date-Time-2ef8643321f48032ad80e8a5b30aa278 for more information
import moment, { Moment } from "moment-timezone";
export interface DateRange {
  start: string;
  end: string;
}

export const FULL_ZONE_NAMES: Record<string, string> = {
  EST: "Eastern Standard Time",
  EDT: "Eastern Daylight Time",
  CST: "Central Standard Time",
  CDT: "Central Daylight Time",
  MST: "Mountain Standard Time",
  MDT: "Mountain Daylight Time",
  PST: "Pacific Standard Time",
  PDT: "Pacific Daylight Time",
};

/**
 * @deprecated: Use `date-fns`
 */
export const weekBoundsFromDate = (momentDate: Moment, timezone: string) => ({
  start: momentDate.clone().tz(timezone).startOf("week"),
  end: momentDate.clone().tz(timezone).endOf("week"),
});

/**
 * Gets offset of a timezone from a basetimezone and converts to string to display on UI.
 */
export const getOffsetFormattedTextBetweenTimezones = (
  date: string,
  baseTimezone: string,
  timezone: string
): string => {
  const baseTimezoneOffset = moment(date).tz(baseTimezone).utcOffset();
  const timezoneOffset = moment(date).tz(timezone).utcOffset();
  const diffInMinutes = Math.abs(timezoneOffset - baseTimezoneOffset);
  if (diffInMinutes === 0) {
    return "";
  }
  const diffInHrs = Math.floor(diffInMinutes / 60);
  const remainingMins = diffInMinutes % 60;
  let offsetText = "";
  if (diffInHrs > 0) {
    offsetText += `${diffInHrs} ${diffInHrs === 1 ? "hr " : "hrs "}`;
  }
  if (remainingMins > 0) {
    offsetText += `${remainingMins} mins `;
  }
  return `${offsetText}${timezoneOffset < baseTimezoneOffset ? "earlier" : "later"}`;
};

/**
 * @deprecated: Use `date-fns`
 */
export const minutesToHm = (totalMinutes: number) => {
  const hours = minutesToHours(Math.abs(totalMinutes));
  const minutes = totalMinutes - hours * 60;
  return { hours, minutes };
};
